import { useEffect, useState } from "react";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import { Box, TextField, Grid, Divider, Typography, Button, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody, Chip } from "@mui/material";
import { FileDownload } from "@mui/icons-material";
import { DialogAlert } from "../Components/DialogAlert";
import { instance, functions, validateFunction } from "../Components/config";
import { useLocation, useNavigate } from "react-router-dom";
import { ExportToCsv } from "export-to-csv";
import { useAuth } from "../Components/AuthContext";

const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const estadoColor = { "Pendiente de revisión": "warning", "Aprobado": "success", "Rechazado": "error" };

const EncabezadoMeses = () => (
  <TableRow>
    <TableCell><strong>Producto</strong></TableCell>
    <TableCell><strong>Subproducto</strong></TableCell>
    <TableCell><strong>Cultivo</strong></TableCell>
    <TableCell><strong>Cultivar</strong></TableCell>
    <TableCell><strong>Observaciones</strong></TableCell>
    {MESES.slice(0, 4).map(m => <TableCell key={m} align="center"><strong>{m.substring(0, 3)}</strong></TableCell>)}
    <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>C1</strong></TableCell>
    {MESES.slice(4, 8).map(m => <TableCell key={m} align="center"><strong>{m.substring(0, 3)}</strong></TableCell>)}
    <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>C2</strong></TableCell>
    {MESES.slice(8, 12).map(m => <TableCell key={m} align="center"><strong>{m.substring(0, 3)}</strong></TableCell>)}
    <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>C3</strong></TableCell>
    <TableCell align="center" sx={{ backgroundColor: "#e0e0e0" }}><strong>Total</strong></TableCell>
  </TableRow>
);

const FilaMeses = ({ detalle, celdas = [] }) => {
  const getMeta = (idx) => {
    const meta = detalle?.find(d => d.idMes === idx + 1);
    return meta ? parseFloat(meta.cantidad) : 0;
  };
  const c1 = [0,1,2,3].reduce((s, i) => s + getMeta(i), 0);
  const c2 = [4,5,6,7].reduce((s, i) => s + getMeta(i), 0);
  const c3 = [8,9,10,11].reduce((s, i) => s + getMeta(i), 0);
  return (
    <TableRow>
      {celdas}
      {[0,1,2,3].map(i => { const v = getMeta(i); return <TableCell key={i} align="center" sx={v > 0 ? { fontWeight: 600 } : { color: "#bbb" }}>{v}</TableCell>; })}
      <TableCell align="center" sx={{ backgroundColor: "#f5f5f5", fontWeight: 600 }}>{c1}</TableCell>
      {[4,5,6,7].map(i => { const v = getMeta(i); return <TableCell key={i} align="center" sx={v > 0 ? { fontWeight: 600 } : { color: "#bbb" }}>{v}</TableCell>; })}
      <TableCell align="center" sx={{ backgroundColor: "#f5f5f5", fontWeight: 600 }}>{c2}</TableCell>
      {[8,9,10,11].map(i => { const v = getMeta(i); return <TableCell key={i} align="center" sx={v > 0 ? { fontWeight: 600 } : { color: "#bbb" }}>{v}</TableCell>; })}
      <TableCell align="center" sx={{ backgroundColor: "#f5f5f5", fontWeight: 600 }}>{c3}</TableCell>
      <TableCell align="center" sx={{ backgroundColor: "#e0e0e0", fontWeight: 700 }}>{c1 + c2 + c3}</TableCell>
    </TableRow>
  );
};

function TablaGeneral({ productos }) {
  const getTotal = (idx) => productos.reduce((s, p) => {
    const meta = p.detalle?.find(d => d.idMes === idx + 1);
    return s + (meta ? parseFloat(meta.cantidad) : 0);
  }, 0);
  const tc1 = [0,1,2,3].reduce((s, i) => s + getTotal(i), 0);
  const tc2 = [4,5,6,7].reduce((s, i) => s + getTotal(i), 0);
  const tc3 = [8,9,10,11].reduce((s, i) => s + getTotal(i), 0);

  return (
    <TableContainer component={Paper} sx={{ marginTop: 2, overflowX: 'auto', maxWidth: '100vw' }}>
      <Table size="small" sx={{ minWidth: 1400 }}>
        <TableHead>
          <TableRow>
            <TableCell><strong>Producto</strong></TableCell>
            <TableCell><strong>Subproducto</strong></TableCell>
            <TableCell><strong>Centro de costo</strong></TableCell>
            <TableCell><strong>Observaciones</strong></TableCell>
            {MESES.slice(0, 4).map(m => <TableCell key={m} align="center"><strong>{m.substring(0, 3)}</strong></TableCell>)}
            <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>C1</strong></TableCell>
            {MESES.slice(4, 8).map(m => <TableCell key={m} align="center"><strong>{m.substring(0, 3)}</strong></TableCell>)}
            <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>C2</strong></TableCell>
            {MESES.slice(8, 12).map(m => <TableCell key={m} align="center"><strong>{m.substring(0, 3)}</strong></TableCell>)}
            <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>C3</strong></TableCell>
            <TableCell align="center" sx={{ backgroundColor: "#e0e0e0" }}><strong>Total</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {productos?.map((producto) => (
            <FilaMeses
              key={producto.id}
              detalle={producto.detalle}
              celdas={[
                <TableCell key="cat">{producto.nombreCatalogo}</TableCell>,
                <TableCell key="prod">{producto.nombreProducto}</TableCell>,
                <TableCell key="loc">{producto.nombreLocalidad}</TableCell>,
                <TableCell key="obs">{producto.observaciones || '-'}</TableCell>
              ]}
            />
          ))}
          {productos?.length > 0 && (
            <TableRow>
              <TableCell colSpan={4} align="right"><strong>Totales</strong></TableCell>
              {[0,1,2,3].map(i => <TableCell key={i} align="center"><strong>{getTotal(i)}</strong></TableCell>)}
              <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>{tc1}</strong></TableCell>
              {[4,5,6,7].map(i => <TableCell key={i} align="center"><strong>{getTotal(i)}</strong></TableCell>)}
              <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>{tc2}</strong></TableCell>
              {[8,9,10,11].map(i => <TableCell key={i} align="center"><strong>{getTotal(i)}</strong></TableCell>)}
              <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>{tc3}</strong></TableCell>
              <TableCell align="center" sx={{ backgroundColor: "#e0e0e0" }}><strong>{tc1 + tc2 + tc3}</strong></TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function TablaSemillas({ productos }) {
  // Aplanar cultivares para fila de totales
  const todosCultivares = productos?.flatMap(p => p.cultivares || []) || [];
  const getTotal = (idx) => todosCultivares.reduce((s, c) => {
    const meta = c.detalle?.find(d => d.idMes === idx + 1);
    return s + (meta ? parseFloat(meta.cantidad) : 0);
  }, 0);
  const tc1 = [0,1,2,3].reduce((s, i) => s + getTotal(i), 0);
  const tc2 = [4,5,6,7].reduce((s, i) => s + getTotal(i), 0);
  const tc3 = [8,9,10,11].reduce((s, i) => s + getTotal(i), 0);

  return (
    <TableContainer component={Paper} sx={{ marginTop: 2, overflowX: 'auto', maxWidth: '100vw' }}>
      <Table size="small" sx={{ minWidth: 1500 }}>
        <TableHead>
          <EncabezadoMeses />
        </TableHead>
        <TableBody>
          {productos?.map((producto) =>
            producto.cultivares?.map((cultivar, idx) => (
              <FilaMeses
                key={cultivar.id}
                detalle={cultivar.detalle}
                celdas={[
                  idx === 0
                    ? <TableCell key="cat" rowSpan={producto.cultivares.length}>{producto.nombreCatalogo}</TableCell>
                    : null,
                  idx === 0
                    ? <TableCell key="prod" rowSpan={producto.cultivares.length}>{producto.nombreProducto}</TableCell>
                    : null,
                  <TableCell key="cult">{cultivar.nombreTipoCultivo}</TableCell>,
                  <TableCell key="culv">{cultivar.nombreCultivar}</TableCell>,
                  <TableCell key="obs">{cultivar.observaciones || '-'}</TableCell>
                ].filter(Boolean)}
              />
            ))
          )}
          {todosCultivares.length > 0 && (
            <TableRow>
              <TableCell colSpan={5} align="right"><strong>Totales</strong></TableCell>
              {[0,1,2,3].map(i => <TableCell key={i} align="center"><strong>{getTotal(i)}</strong></TableCell>)}
              <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>{tc1}</strong></TableCell>
              {[4,5,6,7].map(i => <TableCell key={i} align="center"><strong>{getTotal(i)}</strong></TableCell>)}
              <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>{tc2}</strong></TableCell>
              {[8,9,10,11].map(i => <TableCell key={i} align="center"><strong>{getTotal(i)}</strong></TableCell>)}
              <TableCell align="center" sx={{ backgroundColor: "#f5f5f5" }}><strong>{tc3}</strong></TableCell>
              <TableCell align="center" sx={{ backgroundColor: "#e0e0e0" }}><strong>{tc1 + tc2 + tc3}</strong></TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function UPSE2Detalle() {
  const { user } = useAuth();
  const { state } = useLocation();
  const navigate = useNavigate();
  const id = state?.id;
  const esRevision = state?.validar ?? false;

  const [datos, setDatos] = useState(null);
  const [accion, setAccion] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({ title: "", text: "", redirect: false, page: "/UPSE2", pageState: {} });

  const handleExportCsv = () => {
    const esSemillas = datos.tipoPlanificacion === 'semillas';
    const headers = esSemillas
      ? ["Producto", "Subproducto", "Cultivo", "Cultivar", "Observaciones", ...MESES, "Total"]
      : ["Producto", "Subproducto", "Centro de costo", "Observaciones", ...MESES, "Total"];

    const rows = [];
    datos.productos?.forEach(prod => {
      if (esSemillas) {
        prod.cultivares?.forEach(cult => {
          const fila = {
            Producto: prod.nombreCatalogo,
            Subproducto: prod.nombreProducto,
            Cultivo: cult.nombreTipoCultivo,
            Cultivar: cult.nombreCultivar,
            Observaciones: cult.observaciones || ''
          };
          let total = 0;
          MESES.forEach((mes, i) => {
            const meta = cult.detalle?.find(d => d.idMes === i + 1);
            const val = meta ? parseFloat(meta.cantidad) : 0;
            fila[mes] = val;
            total += val;
          });
          fila.Total = total;
          rows.push(fila);
        });
      } else {
        const fila = {
          Producto: prod.nombreCatalogo,
          Subproducto: prod.nombreProducto,
          "Centro de costo": prod.nombreLocalidad,
          Observaciones: prod.observaciones || ''
        };
        let total = 0;
        MESES.forEach((mes, i) => {
          const meta = prod.detalle?.find(d => d.idMes === i + 1);
          const val = meta ? parseFloat(meta.cantidad) : 0;
          fila[mes] = val;
          total += val;
        });
        fila.Total = total;
        rows.push(fila);
      }
    });

    // Fila de totales
    const filaTotales = esSemillas
      ? { Producto: '', Subproducto: '', Cultivo: '', Cultivar: 'TOTALES', Observaciones: '' }
      : { Producto: '', Subproducto: '', "Centro de costo": 'TOTALES', Observaciones: '' };
    let granTotal = 0;
    MESES.forEach((mes, i) => {
      const suma = rows.reduce((s, r) => s + (r[mes] || 0), 0);
      filaTotales[mes] = suma;
      granTotal += suma;
    });
    filaTotales.Total = granTotal;
    rows.push(filaTotales);

    const csvExporter = new ExportToCsv({
      filename: `REPORTE_UPSE2_${datos.anioMeta}_${id}_${new Date().toISOString().slice(0,10)}`,
      fieldSeparator: ";",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers
    });
    csvExporter.generateCsv(rows);
  };

  useEffect(() => {
    if (!id) { navigate("/UPSE2", { replace: true }); return; }
    instance.get(`/upse2/listById/${id}`)
      .then((res) => setDatos(res.data))
      .catch((err) => {
        setDialog({
          title: "ERROR",
          text: err.response?.status === 500
            ? "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde."
            : err.response?.data?.message || "Error desconocido"
        });
        setOpenDialog(true);
      })
      .finally(() => setIsLoading(false));
  }, [id, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const comentario = e.target.comentario.value;

    if (accion === "3" && comentario.length === 0) {
      setDialog({ title: "Aviso", text: "Si se va a rechazar el formulario, debe agregar el motivo de rechazo." });
      setOpenDialog(true);
      return;
    }

    instance.post('upse2/registrarRevision', {
      id,
      motivo: comentario,
      idEstado: accion,
      idResponsable: datos.idResponsable
    })
      .then(() => {
        setDialog({ title: "Aviso", text: "Se ha registrado correctamente la revisión.", redirect: true, page: "/UPSE2" });
      })
      .catch((err) => {
        setDialog({
          title: "ERROR",
          text: err.response?.status === 500
            ? "Existe algún problema con el servidor."
            : err.response?.data?.message || "Error desconocido"
        });
      })
      .finally(() => setOpenDialog(true));
  };

  if (!state) return null;

  return (
    <Box sx={{ px: 2, mb: 4 }}>
      <Box sx={{ marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <h2 style={{ textAlign: 'center', margin: 0 }}>Detalle de UPSE-2</h2>
        <Chip label={`U2-${id}`} size="small" color="primary" variant="outlined" />
      </Box>

      <Box sx={{ width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading} loadingText="Cargando detalle...">
          {datos && (
            <Box sx={{ width: '100%', marginBottom: 5 }}>
              <Box
                sx={{ padding: "4px", margin: { xs: 0, sm: 1 }, border: { xs: "0", sm: "1px solid #000" } }}
                component="form"
                onSubmit={handleSubmit}
              >
                <Grid container spacing={3} padding={2} rowSpacing={1} sx={{ alignItems: "center" }}>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
                      <h3 style={{ margin: 0 }}>Datos generales</h3>
                      <Chip label={datos.estado} size="small" color={estadoColor[datos.estado] || "default"} />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6} marginTop={2}>
                    <TextField disabled fullWidth label="Lugar de presentación" value={datos.localidad} InputLabelProps={{ shrink: true }} />
                  </Grid>

                  <Grid item xs={12} sm={3} marginTop={2}>
                    <TextField disabled fullWidth label="Año de la meta" value={datos.anioMeta} InputLabelProps={{ shrink: true }} />
                  </Grid>

                  <Grid item xs={12} sm={3} marginTop={2}>
                    <TextField disabled fullWidth label="Techo presupuestario" value={datos.techo} InputLabelProps={{ shrink: true }} />
                  </Grid>

                  <Grid item xs={12} sm={4} marginTop={2}>
                    <TextField disabled fullWidth label="Dirección / programa / unidad" value={datos.direccion} InputLabelProps={{ shrink: true }} />
                  </Grid>

                  <Grid item xs={12} sm={4} marginTop={2}>
                    <TextField disabled fullWidth label="Responsable" value={datos.responsable} InputLabelProps={{ shrink: true }} />
                  </Grid>

                  <Grid item xs={12} sm={4} marginTop={2}>
                    <TextField disabled fullWidth label="Encargado/a de revisión" value={datos.encargado} InputLabelProps={{ shrink: true }} />
                  </Grid>

                  <Grid item xs={12} sm={3} marginTop={2}>
                    <TextField disabled fullWidth label="Tipo de planificación" value={datos.tipoPlanificacion} InputLabelProps={{ shrink: true }} />
                  </Grid>

                  {datos.motivoRechazo && (
                    <Grid item xs={12} sm={9} marginTop={2}>
                      <TextField disabled fullWidth label="Motivo de rechazo" value={datos.motivoRechazo} InputLabelProps={{ shrink: true }} multiline />
                    </Grid>
                  )}

                  <Grid item xs={12} marginTop={3}>
                    <Divider />
                  </Grid>

                  <Grid item xs={12}>
                    <h3 style={{ textAlign: 'center', margin: 0 }}>Detalle de productos</h3>
                  </Grid>

                  <Grid item xs={12}>
                    {datos.tipoPlanificacion === 'semillas'
                      ? <TablaSemillas productos={datos.productos} />
                      : <TablaGeneral productos={datos.productos} />
                    }
                  </Grid>

                  {datos.estado === "Aprobado" && (
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                      <Button variant="contained" color="success" startIcon={<FileDownload />} onClick={handleExportCsv}>
                        Exportar CSV
                      </Button>
                    </Grid>
                  )}

                  {esRevision && validateFunction(user, functions.ReviewUPSE2) && (
                    <>
                      <Grid item xs={12} marginTop={3}>
                        <Divider />
                      </Grid>
                      <Grid item xs={12} sm={12} marginTop={2}>
                        <TextField
                          fullWidth
                          label="Comentarios u observaciones"
                          id="comentario"
                          name="comentario"
                          multiline
                          rows={3}
                          inputProps={{ maxLength: 500 }}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item sm={3} />
                      <Grid item xs={12} sm={3}>
                        <Button color="error" fullWidth variant="contained" type="submit" onClick={() => setAccion("3")}>Rechazar</Button>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Button fullWidth variant="contained" type="submit" onClick={() => setAccion("2")}>Aprobar</Button>
                      </Grid>
                      <Grid item sm={3} />
                    </>
                  )}
                </Grid>
              </Box>
            </Box>
          )}
        </LoaderBoxCircular>

        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
          redirectOnClose={dialog.redirect}
          page={dialog.page}
          pageState={dialog.pageState}
        />
      </Box>
    </Box>
  );
}

export { UPSE2Detalle };
